import React from 'react';
import 'whatwg-fetch';
import { Link } from 'react-router-dom';

import ModalReturnEmployee from '../modal/modalReturnEmployee';

const linkToUser = '/dashboard/user/';

export default class InputEmployeeUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPropsReceived: false,
      isBlackOut: false,
      onUpdate: false,
      inputLabel: this.props.inputLabel ? this.props.inputLabel : null,
      inputValue: this.props.inputValue,
      inputValueSaved: this.props.inputValue,
      isModalReturnEmployee: false,
      textModal: {
        title: 'Choisir employé',
        message: "Vous allez modifier l'employé en charge",
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.cancelUpdate = this.cancelUpdate.bind(this);
    this.submitUpdate = this.submitUpdate.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.onUpdate && nextProps.inputValue != this.props.inputValue) {
      // init or parent's routing with updated props.match.id
      this.setState({
        isPropsReceived: true,
        inputValue: nextProps.inputValue,
        inputValueSaved: nextProps.inputValue,
      });
    }
  }

  render() {
    return (
      <div className='form-group'>
        {this.state.inputLabel && <label>{this.state.inputLabel}</label>}
        <div className='alignHorizontal'>
          <Link to={linkToUser + this.state.inputValue.user.id}>
            <input
              name='inputValue'
              value={this.state.inputValue.user.username}
              onChange={this.handleInputChange}
              type='text'
              className='form-control'
              readOnly
            />
          </Link>
          {!this.state.onUpdate && (
            <button onClick={() => this.onUpdate()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-brush'></span>
            </button>
          )}
        </div>

        <ModalReturnEmployee
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalReturnEmployee}
          onPostResult={(employeeId) => this.submitUpdate(employeeId)}
          onClose={this.cancelUpdate}
          onCancel={this.cancelUpdate}
        ></ModalReturnEmployee>
      </div>
    );
  }

  onUpdate() {
    this.setState({
      isModalReturnEmployee: true,
      onUpdate: true,
    });
  }

  cancelUpdate() {
    this.setState({
      isModalReturnEmployee: false,
      onUpdate: false,
    });
  }

  submitUpdate(employeeId) {
    this.setState({
      onUpdate: false,
    });
    this.props.submitUpdate(employeeId, this.props.inputType);
  }
}
